import { colors, fontWeights, spacing, label, Body2 } from 'ui/theme';
import styled from 'styled-components';

export const PercentageTitle = styled(Body2)`
  font-weight: ${fontWeights.bold};
  margin-bottom: ${spacing.half};
`;

const BaseRow = styled.div`
  display: flex;
  align-items: center;
  > :not(:first-child) {
    margin-left: ${spacing.half};
  }
`;

export const SplitPercentageList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0;
  > :not(:last-child) {
    margin-bottom: ${spacing.half};
  }
`;

export const SplitPercentageItem = styled(BaseRow).attrs({ as: 'li' })`
  > :first-child {
    flex: 0.5;
  }
`;

export const EvenlyDistribute = styled(BaseRow)`
  margin-top: ${spacing.plusHalf};
`;

export const AddMoreSplits = BaseRow;

export const CheckboxLabel = styled.div`
  color: ${colors.textPrimary};
`;

export const ToggleLabel = styled.label`
  ${label}
  margin-bottom: 0;
`;
